module.exports = __webpack_public_path__ + "static/media/point.a76470a6.svg";